export default "__VITE_ASSET__DY6s2ksg__"